import { render, staticRenderFns } from "./canteenList.vue?vue&type=template&id=dd2102a8&"
import script from "./canteenList.vue?vue&type=script&lang=js&"
export * from "./canteenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports